import { useState } from "react";
import { useClickOutside } from "./useClickOutside"; // Assuming useClickOutside is in the same hooks directory

export function useProjectMenuState() {
  const [isOpen, setIsOpen] = useState(false);
  const [showTemplateDialog, setShowTemplateDialog] = useState(false);
  const [showSaveTemplateDialog, setShowSaveTemplateDialog] = useState(false);
  const [showRenameDialog, setShowRenameDialog] = useState(false);
  const [showCloseProjectDialog, setShowCloseProjectDialog] = useState(false);
  const [showDeleteProjectDialog, setShowDeleteProjectDialog] = useState(false);

  const [showSaveAsDialog, setShowSaveAsDialog] = useState(false); // Added Save As state
  const [showLoadProjectDialog, setShowLoadProjectDialog] = useState(false);
  const [showTemplateMenu, setShowTemplateMenu] = useState(false);
  const [showAuthRequiredModal, setShowAuthRequiredModal] = useState(false);
  const [showShareDialog, setShowShareDialog] = useState(false);
  const [showNewProjectConfirmDialog, setShowNewProjectConfirmDialog] = useState(false); // Added state for new project confirmation
  const [showKeyboardShortcutsDialog, setShowKeyboardShortcutsDialog] = useState(false);

  const menuRef = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

  return {
    isOpen,
    setIsOpen,
    showTemplateDialog,
    setShowTemplateDialog,
    showSaveTemplateDialog,
    setShowSaveTemplateDialog,
    showRenameDialog,
    setShowRenameDialog,
    showCloseProjectDialog,
    setShowCloseProjectDialog,
    showDeleteProjectDialog,
    setShowDeleteProjectDialog,

    showSaveAsDialog, // Added Save As state to return
    setShowSaveAsDialog, // Added Save As setter to return
    showLoadProjectDialog,
    setShowLoadProjectDialog,
    showTemplateMenu,
    setShowTemplateMenu,
    showAuthRequiredModal,
    setShowAuthRequiredModal,
    showShareDialog,
    setShowShareDialog,
    showNewProjectConfirmDialog, // Added state
    setShowNewProjectConfirmDialog, // Added setter
    showKeyboardShortcutsDialog,
    setShowKeyboardShortcutsDialog,
    menuRef,
  };
}
